module.exports = "/_next/static/images/all_recommendations-148aeec0daa4c11540ffe59927be3c43.png";